<template>
	<el-dialog
		:title="title"
		:visible.sync="visible"
		:append-to-body="appendToBody"
		width="600px"
		:before-close="handleClose"
		:show-close="showClose"
		:close-on-click-modal="closeOnClickModal"
	>
		<div
			class="addressAnchorScrollBody"
			v-scroll-lazy-load="{
				loadData,
				distance: 100,
				delay: 1000,
				callback: fn => this.$once('hook:beforeDestroy', () => fn()),
			}"
		>
			<div class="pt-4 pb-4 pl-8 pr-8" v-for="item in list" :key="item.id">
				<div class="flex-row-align-center">
					<yx-avatar :size="40" class="mr-8" :src="item.head"></yx-avatar>
					<div>
						<div class="flex-row-align-center">
							<platform-icon style="flex-shrink: 0" :platformId="item.platform_id" />
							<div class="ml-4 color-gy-9 font-h6-medium">
								{{ item.anchor_name }}
							</div>
						</div>

						<div class="color-gy-7 font-h6-regular">{{ item.platform_id | formatPlatformName('unify') }}：{{ anchorAccount(item) }}</div>
					</div>
				</div>
			</div>

			<!-- <p class="pt-20 pb-20 font-h4-regular yx-color-text-regular flex-center">
				<i class="el-icon-loading fz-16 mr-4" v-if="loadmore.status === 'loading'"></i>
				<span :class="loadmore.status === 'nomore' ? 'nomore' : ''">{{ loadmore.text }}</span>
			</p> -->
		</div>

		<span slot="footer">
			<el-button type="primary" @click="confirm">知道了</el-button>
		</span>
	</el-dialog>
</template>
<script>
import { addressManageAnchorList } from '@/api/common';
export default {
	props: {},
	data() {
		return {
			title: '关联达人', // 弹窗标题
			visible: false, // 弹窗显隐

			params: {
				page_index: 1,
				page_size: 20,
			},
			loadmore: {
				text: '加载更多',
				status: 'pending',
			},
			list: [],
		};
	},
	computed: {
		// 弹窗尺寸转换为实际px值
		width() {
			return 600;
		},
	},
	created() {
		this.initData();
	},
	mounted() {},

	methods: {
		anchorAccount(row) {
			const temPF = {
				[dataMap.PLATFORM_DY.value]: row.anchor_account,
				[dataMap.PLATFORM_KS.value]: row.anchor_account,
				// [dataMap.PLATFORM_SP.value]: row.anchor_uid,
			};
			return temPF[row.platform_id];
		},
		loadData() {
			// 有下一页才会请求接口
			if (this.loadmore.status === 'nomore') {
				return;
			}
			this.params.page_index++;
			this.loadmore = {
				text: '加载中...',
				status: 'loading',
			};
			this.getList(true);
		},
		async getList(loadMore) {
			if (!loadMore) {
				this.params.page_index = 1;
			}
			if (loadMore && this.loadmore.status === 'nomore') {
				return;
			}
			let { code, data } = await addressManageAnchorList({
				...this.params,
				delivery_id: this.delivery_id,
			});
			if (code == 0) {
				// 加载更多并且还有下一页才会加载
				if (loadMore) {
					this.list = this.list.concat(data.list);
				} else {
					this.list = data.list;
				}
				this.loadmore = !data.page.page_has
					? {
							text: '已经到底了',
							status: 'nomore',
					  }
					: {
							text: '加载更多',
							status: 'pending',
					  };
			}
		},
		// 主动显示弹窗
		show(delivery_id) {
			this.delivery_id = delivery_id;
			this.visible = true;
			this.getList(false);
		},
		// 清空数据并关闭弹窗
		handleClose() {
			this.visible = false;
		},
		// 确认按钮点击事件
		confirm() {
			this.handleClose();
		},
		// 不需要响应式的数据进行初始化设置
		initData() {
			// 弹窗是否添加到body节点下
			this.appendToBody = true;
			// 是否展示弹窗右上角关闭图标
			this.showClose = true;
			// 点击蒙版是否关闭
			this.closeOnClickModal = false;
		},
	},
	components: {
		
	},
	beforeDestroy() {},
};
</script>
<style lang="less">
.addressAnchorScrollBody {
	max-height: 248px;
	overflow-y: auto;
}
</style>
